export const subNavBarLinks = {
    backgroundColor: "white",
    height: "5vh",
    borderRadius: "0 0 25px 25px",
    cursor: "pointer",
    display: "flex",
    textAlign: "center",
    justifyContent: "center"
};

export const subNavBarLinksSelected = {
    backgroundColor: "blue",
    color: "white",
    fontWeight: "bold",
    height: "5vh",
    borderRadius: "0 0 25px 25px",
    cursor: "pointer",
    display: "flex",
    textAlign: "center",
    justifyContent: "center"
};

export const blueBackground = {
    position: "relative",
    height: "100vh",
    backgroundColor: "rgba(0,0,255,0.5)"
    // paddingTop: "10vh"
    //browser \/\/\/
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center"
};

export const mobile_blueBackground = {
    height: "100vh",
    backgroundColor: "rgba(0,0,255,0.5)"
    // paddingTop: "5svh" //HERE
    //browser \/\/\/
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center"
};

export const insideContainer = {
    position: "absolute",
    top: "10vh",
    // border: "1px solid yellow",
    height: "80vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden"
    // overflowY: "hidden"
};

export const mobile_insideContainer = {
    position: "absolute",
    top: "5svh",
    // border: "1px solid yellow",
    height: "90svh",
    width: "100svw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

export const whileCentredSection = {
    width: "80vw",
    height: "80vh",
    backgroundColor: "rgba(225,255,255,0.6)",
    borderRadius: "25px",
    overflowX: "hidden"
};

export const mobile_whiteCentredSection = {
    width: "80vw",
    height: "70vh",
    backgroundColor: "rgba(225,255,255,0.6)",
    borderRadius: "25px",
    overflowX: "hidden"
};

export const contentContianer = {
    height: "75vh",
    width: "100%",
    overflowY: "scroll"
};

export const mobile_contentContianer = {
    height: "65vh",
    width: "100%",
    overflow: "scroll"
};

export const content = {
    maxHeight: "1000px",
    width: "100%",
    // border: "1px solid red",
    padding: "10px",
    overflow: "hidden"
};

export const backgroundPicture = {
    border: "1px solid black",
    height: "100vh",
    width: "100vw",
    backgroundSize: "cover"
};

export const editorialContent = {
    padding: "10px"
};

//mobile nav bar
export const topNavBar = {
    position: "relative",
    width: "100vw",
    flexDirection: "column",
    justifyContent: "center",
    paddingTop: "10px",
    height: "5svh",
    zIndex: "1"
};

export const topBarIcon = {
    color: "blue",
    paddingLeft: "10px"
};

export const topBar = {
    // height: "30px",
    width: "20%"
};

export const mobileNav_navBody = {
    position: "absolute",
    top: "40px"
};

export const mobileNav_navButton = {
    height: "50px",
    width: "170px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    paddingRight: "20px"
};

export const mobileNav_navButtonSelected = {
    height: "50px",
    width: "170px",
    backgroundColor: "blue",
    color: "white",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    paddingRight: "20px"
};

export const seeMore = {
    padding: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "blue",
    fontWeight: "bold",
    cursor: "pointer"
};
